/* ==========================================================================
  slider.js
========================================================================== */

"use strict";

/* global Splide */

/**
 * Slider for mobile.
 */
document.addEventListener("DOMContentLoaded", function () {

  /**
   * Slider, only for mobile : section-presse
   */
  const revuePress = document.querySelector(".section-presse__grid");

  if( revuePress !== null ) {

    new Splide(".section-presse__grid", {
      mediaQuery: "min",
      type: "slide",
      arrows: false,
      gap: "1.5rem",
      pagination: false,
      padding: { left: "1.5rem", right: "8rem" },
      perPage: 1,
      breakpoints: {
        560: {
          destroy: true,
        },
      },
    }).mount();

  }

  /**
   * Slider, only for mobile : section-citations
   */
  const citationGrid = document.querySelector(".section-citations__grid");

  if( citationGrid !== null ) {

    new Splide(".section-citations__grid", {
      mediaQuery: "min",
      type   : 'loop',
      padding: '20%',
      arrows: false,
      gap: "1.5rem",
      pagination: false,
      perPage: 1,
      breakpoints: {
        560: {
          destroy: true,
        },
      },
    }).mount();

  }

});
